module.exports = __webpack_public_path__ + "images/cabin-v14-latin-regular.woff2";